import gql from 'graphql-tag';

export const createWorkflowAutomationEvent = gql`
  mutation CreateWorkflowAutomationEventMutation($input: CreateWorkflowAutomationEvent!) {
    createWorkflowAutomationEvent(input: $input)
  }
`;
